import { BundlePrice } from 'components/BundlePrice';
import { Box } from '@mui/material';
import { SpecialOfferProps } from '../types';
import { StyledSpecialOffer } from './style';
import { HugeSaleBadge } from 'components/Badge/Sale/HugeSaleBadge';
import BundleSubProduct from 'templates/Bundles/shared/Products/sub';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const HugeSpecialOffer: React.FC<SpecialOfferProps> = ({
  title,
  prices,
  design,
  textColor,
  fontWeight,
  fontSize,
  borderColor,
  buttonColor,
  productsList,
  availability,
  backgroundColor,
  backgroundImage,
  selectOffer,
  inMobileMock = false,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  availabilityText = 'Available',
  collectText = 'Collect',
  specialOfferRef,
  timer,
  tooltipOpenEventHandler,
}) => {
  const mainProduct = productsList[0];
  const subProducts = productsList?.slice(1);
  const onlyMain = subProducts.length <= 0;

  return (
    <StyledSpecialOffer
      ref={specialOfferRef}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      textColor={textColor}
      fontWeight={fontWeight}
      fontSize={fontSize}
      productsHeight={onlyMain ? '33%' : '50%'}
      mainHeight={onlyMain ? '100%' : '60%'}
      onClick={selectOffer}
      title={title}
      className={inMobileMock ? ' promotion--iphone-mock' : ''}
    >
      <Box className="backgroundImage">
        {salePercentage > 0 && (
          <HugeSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        <h2>{title}</h2>
        <Box className={`productsContainer huuuge`}>
          {mainProduct && (
            <Box className="products mainProducts huuuge">
              <Box className="product">
                {mainProduct?.images?.product && (
                  <Box height="32px" width="32px" className="image-container">
                    <img
                      src={mainProduct.images.product}
                      alt=""
                      className="image-container--image"
                    />
                  </Box>
                )}
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  className="amounts-container"
                >
                  <AutoTextSize
                    as="h4"
                    mode="oneline"
                    maxFontSizePx={18}
                    minFontSizePx={6}
                    data-text={mainProduct.quantityDisplay}
                  >
                    {mainProduct.quantityDisplay}
                  </AutoTextSize>
                  {salePercentage > 0 && (
                    <AutoTextSize
                      as="p"
                      mode="oneline"
                      maxFontSizePx={14}
                      minFontSizePx={6}
                      className="stroked"
                    >
                      {mainProduct.strokedSaleQuantity}
                    </AutoTextSize>
                  )}
                </Box>
              </Box>
            </Box>
          )}

          {subProducts.length > 0 && (
            <>
              <Box className="products secondaryProduct">
                {subProducts.map((product, i) => {
                  return (
                    <BundleSubProduct
                      className="huge-sub-product"
                      key={i}
                      name={product.name}
                      itemClassName={'carousel-item'}
                      textFontColorHex={'white'}
                      quantityDisplay={product.quantityDisplay}
                      productType={product.productType}
                      quantity={product.quantity}
                      publisherProductId={product.publisherProductId}
                      index={i - 1}
                      images={product.images}
                      rarityProductInfo={product.rarityProductInfo}
                      itemRef={specialOfferRef}
                      badgeText={product.badgeText}
                      isFullWidth={false}
                      tooltipOpenEventHandler={tooltipOpenEventHandler}
                    />
                  );
                })}
              </Box>
            </>
          )}
        </Box>
        <BundlePrice
          whiteStripe={true}
          height="30px"
          prices={prices}
          buttonTextColor="white"
          buttonColor={buttonColor}
          type={design}
          textShadow="0px 2px 0px #000000"
          borderRadius="0 0 9px 9px"
          isPreview={inMobileMock}
          availabilityText={availabilityText}
          isFree={isFree}
          buttonText={collectText}
          timer={timer}
          availability={availability}
        />
      </Box>
    </StyledSpecialOffer>
  );
};
